export default __webpack_public_path__ + "static/profile-c4777ccc1c69e4014870a4757706ed7d.png";